class WIfloatingatc extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        document.addEventListener("DOMContentLoaded", function () {
            const floatingAtc = document.querySelector(".WI_floatingAtcObserver");
            const addBtn = this.querySelector('.WI_floatingProductAtc_main');
        
            if (!floatingAtc || !addBtn) return; // Ensure elements exist
        
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            addBtn.style.bottom = "-100%"; // Hide when visible
                        } else {
                            addBtn.style.bottom = "0%"; // Show when not visible
                        }
                    });
                },
                { rootMargin: "280px 0px 100px 0px", threshold: 0.1 } // Adjust sensitivity
            );
        
            observer.observe(floatingAtc);
        });
        this.varGid = null;
        this.floatingAtcIsOpen = false;
        this.selectVaraint();
        this.setupFloatingAtc();
        this.closePop();
    }

    // closing pop function
    closePop() {
        // > Press close button
        this.querySelector('.WI_floatingProductAtc_clsBtn').addEventListener('click', ()=>{
            this.querySelector('.WI_floatingProductAtc_varCon').style.maxHeight = '0';
            this.floatingAtcIsOpen = false;
        });
    }

    // open and close floating atc
    setupFloatingAtc() {
        this.addEventListener('click', (event) => {
            let atcBtn = event.target.closest('.WI_floatingProductAtc_btnPress');
            let hasVariant = this.getAttribute('data-hasvar');
            console.log(hasVariant);
            console.log(this.floatingAtcIsOpen);
            
            if (!atcBtn) return;
    
            if (!this.floatingAtcIsOpen && hasVariant === null) {
                this.querySelector('.WI_floatingProductAtc_varCon').style.maxHeight = '500px';
                this.floatingAtcIsOpen = true;
            } else {
                this.fetchProductData(atcBtn);
            }
        });
    }

    // Floating atc variant select
    selectVaraint() {
        this.addEventListener('click', (event)=>{
            let varInp = event.target.closest("input[type='radio']");
            if (varInp) {
                let varArray = [];
                let isInput = this.querySelectorAll("input[type='radio']");
                isInput.forEach(inp => {  
                    if (inp.checked) {
                        varArray.push(inp.value);
                        console.log(varArray);
                    }
                });
                if (varArray.length > 0) {
                    this.updateProductOptions(varArray);
                }
            }
        })
    } 

    // Update the Product options
updateProductOptions(varArray) {
    let varJSON = this.querySelector('script[type="application/json"]');
    if (varJSON) {
        let variantData = JSON.parse(varJSON.textContent);
        for (let i = 0; i < variantData.length; i++) {
            if (JSON.stringify(variantData[i].options) == JSON.stringify(varArray)) {
                console.log(variantData[i].id);
                this.updateProductVariant(variantData[i].id);
                let GlobalID = variantData[i].id;
                this.varGid = GlobalID;
                break;
            }
        }
        
    }
}

// Updating product variant
async updateProductVariant(variantid) {
    this.querySelector('.WI_floatingProductAtc_btnPress').disabled = true;
    try {
        let productData = this.getAttribute('data-producthandle');
        let res = await fetch(`/products/${productData}?view=product.wi-floatingatc-variant&variant=${variantid}`);
        let data = await res.text();
        let html_div = document.createElement('div');
        html_div.innerHTML = data;
        let productCardVariant = html_div.querySelector('.WI_floatingAtcVaraint_main');
        this.querySelector('.WI_floatingAtcVaraint_main').innerHTML = productCardVariant.innerHTML;
        this.querySelector('.WI_floatingProductAtc_btnPress').disabled = false;
    } catch (error) {
        console.log(error);
    }
}
fetchProductData(atcBtn) {
    let variantid = this.varGid || atcBtn.getAttribute('data-varId');

    if (!variantid) return;

    // Directly call fetch function
    this.addFetch(variantid);
}

async addFetch(variantid) {
    this.querySelector('.WI_floatingProductAtc_btnPress svg').style.display = 'flex';
    try {
        let formData = {
            'items': [{
                'id': variantid,
                'quantity': 1
            }]
        };
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        this.querySelector('.WI_floatingProductAtc_varCon').style.maxHeight = '0';
        this.floatingAtcIsOpen = false;
        document.dispatchEvent(new CustomEvent('wi:add', {bubbles: true}));
        this.querySelector('.WI_floatingProductAtc_btnPress svg').style.display = 'none';
    } catch (error) {
        console.log(error);
    }
}
    

    
}

customElements.define('wi-floatingatc', WIfloatingatc);